<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">重/补修申请</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-select v-model="queryForm.semesterCode" placeholder="学年学期" style="width: 100%;" @change="handleSemesterChange">
                            <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button v-show="!stuAuthVisible" @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多</el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row>
                    <el-select v-model="queryForm.semesterCode" placeholder="学年学期" @change="handleSemesterChange">
                        <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue"
                            :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-input v-if="teaAuthVisible" v-model="queryForm.stuCode" placeholder="学号 / 姓名"></el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.deptCode" placeholder="所属系部" clearable>
                        <el-option v-for="(item, index) in comboOption.dept" :key="item.comboValue"
                            :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.majorCode" placeholder="所属专业" clearable>
                        <el-option v-for="(item, index) in comboOption.major" :key="item.comboValue"
                            :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.courseTypeCode" placeholder="课程类型" clearable>
                        <el-option v-for="(item, index) in comboOption.courseType" :key="item.comboValue"
                            :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.courseName" placeholder="课程名称"></el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.applyTypeCode" placeholder="申请类型" clearable>
                        <el-option v-for="(item, index) in comboOption.applyType" :key="item.comboValue"
                            :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>

                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>


            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有申请信息</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学号：</label>{{ item.stuCode }}</p>
                        <p><label for="">姓名：</label>{{ item.stuName }}</p>
                        <p><label for="">课程代码：</label>{{ item.courseCode }}</p>
                        <p><label for="">课程名称：</label>{{ item.courseName }}</p>
                        <p><label for="">申请类型：</label>{{ item.applyTypeName }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput">
                        <el-button v-if="item.hasCourse == '0'" type="primary" @click="showDetailInfo(item)">
                            <i class="el-icon-tickets"></i>&nbsp;详情
                        </el-button>
                        <el-button v-if="item.hasCourse == '1' && item.applyState == '0'"
                            @click="showApplyDialog('apply', item);" type="success" :disabled="applyButtonDisable">
                            <i class="el-icon-edit"></i>&nbsp;申请
                        </el-button>
                        <el-button v-if="item.applyState == '1'" @click="showApplyDialog('view', item);" type="primary">
                            <i class="el-icon-view"></i>&nbsp;查看
                        </el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" title="详情" :visible.sync="detailDialogVisible" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form label-width="84px" label-position="left" width="100%">
                        <el-form-item label="学号">
                            {{selectRowData.stuCode}}
                        </el-form-item>
                        <el-form-item label="姓名">
                            {{selectRowData.stuName}}
                        </el-form-item>
                        <el-form-item label="课程名称">
                            {{selectRowData.courseName}}
                        </el-form-item>
                        <el-form-item label="课程类型">
                            {{selectRowData.courseTypeName}}
                        </el-form-item>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="课程代码">
                                    {{selectRowData.courseCode}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="学分">
                                    {{selectRowData.credit}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="总评成绩">
                                    {{selectRowData.score}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="补考成绩">
                                    {{selectRowData.resitScore}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="重修成绩">
                                    {{selectRowData.retakeScore}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="重修次数">
                                    {{selectRowData.retakeNum}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="申请类型">
                                    {{selectRowData.applyTypeName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="申请状态">
                                    <div>
                                        <span v-if="selectRowData.applyState === '1'">已申请</span>
                                        <span v-else>未申请</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-scrollbar>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="detailDialogVisible = false">关 闭
                    </el-button>
                </div>
            </el-dialog>

            <el-dialog id="mainDialog" class="formDialog customElRow" title="详情" :visible.sync="applyDialogVisible" width="90%" @closed="closeDialog">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="applyForm" :model="applyForm" label-width="84px" label-position="left" width="100%">
                        <el-form-item label="学号">
                            {{applyForm.stuCode}}
                        </el-form-item>
                        <el-form-item label="姓名">
                            {{applyForm.stuName}}
                        </el-form-item>
                        <el-form-item label="课程名称">
                            {{applyForm.courseName}}
                        </el-form-item>
                        <el-form-item label="课程类型">
                            {{applyForm.courseTypeName}}
                        </el-form-item>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="开课序号">
                                    {{applyForm.courseOrderNum}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="学分">
                                    {{applyForm.credit}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="总评成绩">
                                    {{applyForm.score}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="补考成绩">
                                    {{applyForm.resitScore}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="重修成绩">
                                    {{applyForm.retakeScore}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="重修次数">
                                    {{applyForm.retakeNum}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="申请类型">
                                    {{applyForm.applyTypeName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="申请状态">
                                    <div>
                                        <span v-if="applyForm.applyState === '1'">已申请</span>
                                        <span v-else>未申请</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-form-item label="申请课程" prop="applyPlanCode" :rules="[{required: true, message: '请选择申请课程'}]">
                            <el-select v-model="applyForm.applyPlanCode" :disabled="isApplyState" placeholder="请选择"
                                style="width:95%;" @change="handleApplyCourseChange">
                                <el-option v-for="(item, index) in comboOption.applyCourse" :key="item.comboValue"
                                    :value="item.comboValue" :label="item.comboName" style="width: 250px;">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div v-show="courseDetailInfoVisible">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="剩余名额">
                                        {{ courseInfo.stuNum }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="开课班级">
                                        {{ courseInfo.className }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="课程名称">
                                        {{ courseInfo.courseName }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="授课教师">
                                        {{ courseInfo.teaName }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="授课场地">
                                        {{ courseInfo.siteName }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="开课周次">
                                        {{ courseInfo.week }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="开课时间">
                                        {{ courseInfo.time }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-form>
                </el-scrollbar>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="primary" @click="confirmApply" :disabled="isApplyState">申 请</el-button>
                    <el-button @click="timetableDialogVisible = true" style="margin-left:10px;">课 表</el-button>
                    <el-button @click="applyDialogVisible = false" style="margin-left:10px;">关 闭</el-button>
                </div>
            </el-dialog>

            <el-dialog id="mainDialog" class="formDialog" title="课表信息" :visible.sync="timetableDialogVisible" width="90%" @open="queryTimetable">
                <div id="contentArea" v-loading="timetableLoading" element-loading-text="课表加载中"
                    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
                    <el-scrollbar view-style="height:65vh;overflow:hidden;" id="timetableDialogScroll" ref="timetableDialogScroll">
                        <el-form>
                            <el-form-item>
                                <table id="timetable" class="timetable" :style="{width: (32 * weekDayNum + 40) + 'vw'}">
                                    <thead>
                                        <tr>
                                            <th class="timetableTitle separetor contentHide" colspan="3"></th>
                                            <th class="timetableTitle separetor weekDayName contentHide"
                                                v-for="(item, index) in weekDayName"
                                                v-html="item + (weekDayDate==null?'':('<br/>'+weekDayDate[index]))">
                                            </th>
                                        </tr>
                                    </thead>
                                    <tr v-if="forenoonNum > 0">
                                        <td class="timetableTitle separetor contentHide" :rowspan="forenoonNum"
                                            style="width:10vw;">上<br /><br />午</td>
                                        <td class="timetableTitle contentHide" style="width:10vw;">1</td>
                                        <td class="timetableTitle contentHide" style="width:20vw;"
                                            v-html="timeQuantum[0]"></td>
                                        <td v-for="m in weekDayNum" class="timetableContent" :id="'cell_' + (m-1)"
                                            :name="'weekDayNum_' + m" ></td>
                                    </tr>
                                    <template v-if="forenoonNum > 1">
                                        <tr v-for="n in forenoonNum-1">
                                            <td
                                                :class="n < forenoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">
                                                {{ n+1 }}
                                            </td>
                                            <td :class="n < forenoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                                v-html="timeQuantum[n]"></td>
                                            <td :class="n < forenoonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum"
                                                class="timetableContent" :id="'cell_' + (n*weekDayNum + m-1)"
                                                :name="'weekDayNum_' + m"></td>
                                        </tr>
                                    </template>
                                    <tr v-if="noonNum > 0">
                                        <td class="timetableTitle separetor contentHide" :rowspan="noonNum">
                                            中<br /><br />午</td>
                                        <td class="timetableTitle contentHide">1</td>
                                        <td class="timetableTitle contentHide" v-html="timeQuantum[forenoonNum]"></td>
                                        <td v-for="m in weekDayNum" class="timetableContent"
                                            :id="'cell_' + (forenoonNum*weekDayNum + m-1)" :name="'weekDayNum_' + m"></td>
                                    </tr>
                                    <template v-if="noonNum > 1">
                                        <tr v-for="n in noonNum-1">
                                            <td
                                                :class="n < noonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">
                                                {{ n+1 }}
                                            </td>
                                            <td :class="n < noonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                                v-html="timeQuantum[forenoonNum+n]"></td>
                                            <td :class="n < noonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum"
                                                class="timetableContent"
                                                :id="'cell_' + (forenoonNum*weekDayNum + n*weekDayNum + m-1)"
                                                :name="'weekDayNum_' + m" ></td>
                                        </tr>
                                    </template>
                                    <tr v-if="afternoonNum > 0">
                                        <td class="timetableTitle separetor contentHide" :rowspan="afternoonNum">
                                            下<br /><br />午
                                        </td>
                                        <td class="timetableTitle contentHide">1</td>
                                        <td class="timetableTitle contentHide"
                                            v-html="timeQuantum[forenoonNum+noonNum]"></td>
                                        <td v-for="m in weekDayNum" class="timetableContent"
                                            :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + m-1)"
                                            :name="'weekDayNum_' + m" ></td>
                                    </tr>
                                    <template v-if="afternoonNum > 1">
                                        <tr v-for="n in afternoonNum-1">
                                            <td
                                                :class="n < afternoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'">
                                                {{ n+1 }}
                                            </td>
                                            <td :class="n < afternoonNum-1 ? 'timetableTitle contentHide' : 'timetableTitle separetor contentHide'"
                                                v-html="timeQuantum[forenoonNum+noonNum+n]"></td>
                                            <td :class="n < afternoonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum"
                                                class="timetableContent"
                                                :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + n*weekDayNum + m-1)"
                                                :name="'weekDayNum_' + m" ></td>
                                        </tr>
                                    </template>
                                    <tr v-if="eveningNum > 0">
                                        <td class="timetableTitle contentHide" :rowspan="eveningNum">晚<br /><br />上</td>
                                        <td class="timetableTitle contentHide">1</td>
                                        <td class="timetableTitle contentHide"
                                            v-html="timeQuantum[forenoonNum+noonNum+afternoonNum]"></td>
                                        <td v-for="m in weekDayNum" class="timetableContent"
                                            :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + m-1)"
                                            :name="'weekDayNum_' + m" ></td>
                                    </tr>
                                    <template v-if="eveningNum > 1">
                                        <tr v-for="n in eveningNum-1">
                                            <td class="timetableTitle contentHide">{{ n+1 }}</td>
                                            <td class="timetableTitle contentHide"
                                                v-html="timeQuantum[forenoonNum+noonNum+afternoonNum+n]"></td>
                                            <td v-for="m in weekDayNum" class="timetableContent"
                                                :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + n*weekDayNum + m-1)"
                                                :name="'weekDayNum_' + m" ></td>
                                        </tr>
                                    </template>
                                </table>
                           </el-form-item>
                        </el-form>
                    </el-scrollbar>
                </div>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="timetableDialogVisible = false">关 闭
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import {
        confirmMsg,
        showNotify
    } from "utils/message";

    export default {
        data() {
            return {
                comboOption: {
                    semester: null,
                    dept: null,
                    major: null,
                    courseType: null,
                    applyCourse: null,
                    applyType: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    semesterCode: null,
                    stuCode: null,
                    stuName: null,
                    deptCode: null,
                    majorCode: null,
                    courseName: null,
                    courseTypeCode: null,
                    applyTypeCode: null,
                },
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: {},
                queryDialogVisible: false,
                userRole: null,
                teaAuthVisible: false,
                teaAuthVisible: false,
                tableData: [],
                curSemesterCode: null,
                detailDialogVisible: false,
                selectRowData: [],
                applyDialogVisible: false,
                applyForm: {
                    semesterCode: null,
                    semesterName: null,
                    stuCode: null,
                    stuName: null,
                    gradeCode: null,
                    planCode: null,
                    courseCode: null,
                    courseName: null,
                    courseOrderNum: null,
                    credit: null,
                    score: null,
                    resitScore: null,
                    retakeScore: null,
                    retakeNum: null,
                    applyPlanCode: null,
                    applyTypeCode: null,
                    isDivideClassCourse: null,
                    isIgnoreConflict: false,
                },
                isApplyState: false,
                //课表基本参数
                weekDayNum: null,
                weekDayName: null,
                weekDayDate: null,
                timeName: null,
                forenoonNum: null,
                noonNum: null,
                afternoonNum: null,
                eveningNum: null,
                timeQuantum: [],
                //课表内容
                timetableInfo: null,
                cellContent: [],
                timetableLoading: false,
                singleWeek: false,
                timetableDialogVisible: false,
                loadingMask: null,
                isTimeConflict: false,
                courseDetailInfoVisible: false,
                courseInfo: {
                    stuNum: null,
                    className: null,
                    courseName: null,
                    teaName: null,
                    siteName: null,
                    week: null,
                    time: null,
                },
                applyButtonDisable: false,
                teaAuthVisible: false,
                stuAuthVisible: false,
            };
        },
        created() {
            this.init();
        },
        mounted() {},
        methods: {
            async init() {
                this.queryUserInfo()
                this.initCombo()
            },
            showHomePage() {
                this.$router.push('/m/wx/home');
            },
            loadStateImg(row){
                if(row.hasCourse==='0'){
                    //未开课
                    return require('image/mobile/auditState/wkk.png');
                }else{
                   if(row.applyState === '0'){
                       //待申请
                       return require('image/mobile/auditState/dsq.png');
                   }else{
                       //已申请
                       return require('image/mobile/auditState/ysq.png');
                   }
                }
            },
            async queryUserInfo() {
                await this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;

                    if (userInfo) {
                        let roleInfo = userInfo.roles;

                        for (var roleCode in roleInfo) {
                            this.userRole = roleInfo[roleCode];
                        }

                        if (this.userRole == '学生') {
                            this.stuAuthVisible = true;
                            this.queryForm.stuCode = userInfo.phone;
                            this.queryForm.stuName = userInfo.name;
                        } else {
                            this.teaAuthVisible = true;
                        }
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            async initCombo() {
                await this.$api.scoreManage.retake.initApplyCombo({}).then((res) => {
                    this.comboOption.semester = res.data.data.semesterComboData;
                    this.comboOption.dept = res.data.data.deptComboData;
                    this.comboOption.major = res.data.data.majorComboData;
                    this.comboOption.courseType = res.data.data.courseTypeComboData;
                    this.comboOption.applyType = res.data.data.applyTypeComboData;

                    this.curSemesterCode = res.data.data.curSemesterCode;
                    this.queryForm.semesterCode = this.curSemesterCode;
                    this.initBlankTimetable();
                    this.queryList();
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleSemesterChange(){
                this.curSemesterCode = this.queryForm.semesterCode;
                this.initBlankTimetable();
                this.queryList();
            },
            handleApplyCourseChange(value) {
                //查询排课详情
                const courseComboInfo = this.getCourseArrnageInfo(value);
                // this.handleTimetableStyle(courseArrangeInfo);
                this.handleCourseInfo(value);
                this.applyForm.courseArrangeInfo = courseComboInfo.otherInfo;
                this.applyForm.isDivideClassCourse = courseComboInfo.isDivideClassCourse;
            },
            handleCourseInfo(planCode){
                const comboData = this.comboOption.applyCourse;
                for (let i=0; i<comboData.length; i++) {
                    if (comboData[i].comboValue === planCode) {
                        const tempCourseInfoArray = comboData[i].comboName.split(' - ');
                        this.courseInfo.stuNum = tempCourseInfoArray[0].replace('剩余名额:', '');
                        this.courseInfo.className = tempCourseInfoArray[1];
                        this.courseInfo.courseName = tempCourseInfoArray[2];
                        this.courseInfo.teaName = '';
                        this.courseInfo.siteName = '';
                        this.courseInfo.week = '';
                        this.courseInfo.time = '';
                        this.applyForm.teaName = '';
                        this.applyForm.siteName = '';
                        this.applyForm.courseTime = '';

                        const courseInfoArray = tempCourseInfoArray[3].split("丨");
                        let separator = '';
                        for (let i=0; i<courseInfoArray.length; i++) {
                            const courseDetailInfoArray = courseInfoArray[i].split(' * ');
                            this.courseInfo.teaName += separator + courseDetailInfoArray[0];
                            this.courseInfo.siteName += separator + courseDetailInfoArray[1];
                            this.courseInfo.week += separator + courseDetailInfoArray[2];
                            this.courseInfo.time += separator + courseDetailInfoArray[3];
                            this.applyForm.teaName += separator + courseDetailInfoArray[0];
                            this.applyForm.siteName += separator + courseDetailInfoArray[1];
                            this.applyForm.courseTime += separator + courseDetailInfoArray[2] + ' ' + courseDetailInfoArray[3];
                            separator = '丨';
                        }

                        this.courseDetailInfoVisible = true;
                        break;
                    }
                }
            },
            getCourseArrnageInfo(planCode) {
                let courseArrangeInfo = '';
                const comboData = this.comboOption.applyCourse;
                for (let i = 0; i < comboData.length; i++) {
                    if (comboData[i].comboValue === planCode) {
                        courseArrangeInfo = comboData[i];
                        break;
                    }
                }

                return courseArrangeInfo;
            },
            handleTimetableStyle(courseArrangeInfo) {
                this.restTimetableStyle();

                if (courseArrangeInfo.length>0 && this.timetableInfo) {
                    const timeArray = courseArrangeInfo.split(',');

                    for (let index in timeArray) {
                        const tempArray = timeArray[index].split('@');
                        const orderNum = tempArray[0];
                        const weekNumArray = tempArray[1].split('#');

                        for (let i = 0; i < this.timetableInfo.length; i++) {
                            if (orderNum == this.timetableInfo[i].orderNum) {
                                let ele = document.getElementById('cell_' + i);

                                if (this.timetableInfo[i].weekNumDetail != null) {
                                    const tempWeekNumArray = this.timetableInfo[i].weekNumDetail.split('#');
                                    ele.style.color = '#FFFFFF';

                                    if (this.verifyWeekNum(weekNumArray, tempWeekNumArray)) {
                                        ele.style.background = 'rgba(255, 0, 0, 0.5)';
                                        this.isTimeConflict = true;
                                    } else {
                                        ele.style.background = 'rgba(85, 255, 127, 0.7)';
                                        this.isTimeConflict = false;
                                    }
                                } else {
                                    ele.style.background = 'rgba(85, 255, 127, 0.7)';
                                    this.isTimeConflict = false;
                                }

                                break;
                            }
                        }
                    }
                }
            },
            verifyWeekNum(weekNumArray, tempWeekNumArray) {
                for (let i = 0; i < weekNumArray.length; i++) {
                    for (let j = 0; j < tempWeekNumArray.length; j++) {
                        if (weekNumArray[i] == tempWeekNumArray[j]) {
                            return true;
                        }
                    }
                }

                return false;
            },
            restTimetableStyle() {
                if(this.timetableInfo){
                    for (let i = 0; i < this.timetableInfo.length; i++) {
                        let ele = document.getElementById('cell_' + i);
                        ele.style.background = '';
                        ele.style.color = '';
                    }
                }
            },
            confirmApply() {
                this.$refs['applyForm'].validate((valid) => {
                    if (valid) {
                        let confirmTips = '申请重修后无法取消，是否继续？';
                        if (this.applyForm.applyTypeCode === '2') {
                            confirmTips = '申请补修后该课程无法再进行学分认定，是否继续？';
                        }

                        confirmMsg(confirmTips, 'el-message-box-mobile').then(() => {
                            this.applyRec();
                        });
                    } else {
                        return false;
                    }
                });
            },
            applyRec() {
                this.showLoadingMask('申请中，请稍候...');
                this.isApplyState = true;

                this.$api.scoreManage.retake.apply({
                    data: this.applyForm,
                }).then((res) => {
                    const state = res.data.data.state;
                    const msg = res.data.data.msg;
                    this.isApplyState = false;
                    this.closeLoadingMask();

                    if (state == 'Success') {
                        showNotify('成功', msg ? msg : "申请成功", 'success', 1500);
                        this.requeryList();
                        this.applyDialogVisible = false;
                    } else {
                        showNotify('失败', msg ? msg : "申请失败", 'error', 3000);
                    }
                }).catch((err) => {
                    this.isApplyState = false;
                    this.closeLoadingMask();
                    showNotify('错误', err, 'error', 3000);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.showLoadingMask('信息加载中，请稍候...');
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.scoreManage.retake.applyList({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = this.tableData.concat(response.data.data.list);
                    this.closeLoadingMask();
                    this.tableLoading = false;
                }).catch((err) => {
                    this.closeLoadingMask();
                    this.tableLoading = false;
                    console.log(err);
                });
            },
            initBlankTimetable() {
                this.$api.timetableManage.common.baseParam({
                    data: {
                        semesterCode: this.queryForm.semesterCode,
                        weekNum: this.queryForm.weekNum,
                    },
                }).then((res) => {
                    this.weekDayNum = parseInt(res.data.data.baseParam.weekDayNum, 10);
                    this.weekDayName = res.data.data.baseParam.weekDayName.split(',');
                    this.forenoonNum = parseInt(res.data.data.baseParam.forenoonNum, 10);
                    this.noonNum = parseInt(res.data.data.baseParam.noonNum, 10);
                    this.afternoonNum = parseInt(res.data.data.baseParam.afternoonNum, 10);
                    this.eveningNum = parseInt(res.data.data.baseParam.eveningNum, 10);
                    //处理时间名称
                    this.handleTimeNameInfo();
                    //处理节次时间
                    this.handleOrderNumTimeInfo(res.data.data.baseParam.timeQuantum);

                }).catch((err) => {
                    console.log(err);
                });
            },
            handleTimeNameInfo() {
                this.timeName = new Array();

                for (let i = 0; i < this.forenoonNum; i++) {
                    this.timeName.push('上午' + (i + 1));
                }
                for (let i = 0; i < this.noonNum; i++) {
                    this.timeName.push('中午' + (i + 1));
                }
                for (let i = 0; i < this.afternoonNum; i++) {
                    this.timeName.push('下午' + (i + 1));
                }
                for (let i = 0; i < this.eveningNum; i++) {
                    this.timeName.push('晚上' + (i + 1));
                }
            },
            handleOrderNumTimeInfo(tempTimeQuantum) {
                const timeQuantumArray = tempTimeQuantum.split(',');
                const _this = this;
                this.timeQuantum = new Array();
                // timeQuantumArray.forEach(element => {
                //     console.log();
                //     _this.timeQuantum.push(element.split('@')[1].replace('~',
                //         '<div style="height:5px;margin-top:-10px">|</div>'));
                // });
                timeQuantumArray.forEach(element => {
                    _this.timeQuantum.push(element.split('@')[1].replace('~',
                        '<br/>'));
                });
            },
            requeryList() {
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
            },
            handleFilter() {
                this.requeryList();
                this.queryDialogVisible = false;
            },
            handleReset() {
                if (this.teaAuthVisible) {
                    this.queryForm.stuCode = null;
                    this.queryForm.stuName = null;
                }
                this.queryForm.courseName = null;
                this.queryForm.auditState = null;
                this.tableLoading = false;
                this.queryDialogVisible = false;
                this.requeryList();
            },
            handleScroll() {
                if (this.checkVisible() && !this.tableLoading && this.total > this.tableData.length) {
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if (ele) {
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                } else {
                    return false;
                }
            },
            scrollToTop() {
                const ele = document.getElementById('listArea');
                if (ele) {
                    ele.scrollTop = 0;
                }
            },
            querySearchStu(queryString, cb) {
                let students = this.students;
                let results = queryString ? students.filter(this.createFilter(queryString)) : students;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (student) => {
                    return (student.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            clearSelectStu() {
                document.activeElement.blur();
            },
            loadCourseCombo() {
                this.$api.creditIdentified.changeMajor.courseCombo({
                    data: {
                        stuCode: this.applyForm.stuCode,
                        oriPlanCode: this.applyForm.oriPlanCode,
                        newPlanCode: this.applyForm.newPlanCode,
                    },
                }).then((res) => {
                    this.comboOption.oriCourseInfo = res.data.data.oriCourseComboData;
                    this.comboOption.newCourseInfo = res.data.data.newCourseComboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            showDetailInfo(rowData) {
                this.selectRowData = rowData
                this.detailDialogVisible = true;
            },
            restoreScroll() {
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
            showApplyDialog(type, rowData) {
                if(type == 'apply'){
                    this.applyButtonDisable = true;

                    this.$api.scoreManage.retake.checkApplyOpenState({
                        data: {
                            semesterCode: this.curSemesterCode,
                        },
                    }).then((res) => {
                        if(res.data.data.state == 'open'){
                            this.fillApplyForm(type, rowData);
                        }else{
                            this.$alert('当前所选的学期暂未开放重修 / 补修申请', '提示', {
                                confirmButtonText: '确定',
                                customClass: 'el-message-box-mobile',
                            });
                        }

                        this.applyButtonDisable = false;
                    }).catch((err) => {
                        this.$alert('当前所选的学期暂未开放重修 / 补修申请', '提示', {
                            confirmButtonText: '确定',
                            customClass: 'el-message-box-mobile',
                        });
                        this.applyButtonDisable = false;
                        console.log(err);
                    });
                }else{
                    this.fillApplyForm(type, rowData);
                }
            },
            fillApplyForm(type, rowData){
                if (type == 'apply') {
                    this.isApplyState = false;
                    this.courseDetailInfoVisible = false;
                } else {
                    this.isApplyState = true;
                }
                this.applyForm.semesterCode = this.curSemesterCode;
                this.applyForm.semesterName = rowData.semesterName;
                this.applyForm.stuCode = rowData.stuCode;
                this.applyForm.stuName = rowData.stuName;
                this.applyForm.gradeCode = rowData.gradeCode;
                this.applyForm.planCode = rowData.planCode;
                this.applyForm.courseCode = rowData.courseCode;
                this.applyForm.courseName = rowData.courseName;
                this.applyForm.courseTypeName = rowData.courseTypeName;
                this.applyForm.courseOrderNum = rowData.courseOrderNum;
                this.applyForm.credit = rowData.credit;
                this.applyForm.score = rowData.score;
                this.applyForm.resitScore = rowData.resitScore;
                this.applyForm.retakeScore = rowData.retakeScore;
                this.applyForm.retakeNum = rowData.retakeNum;
                this.applyForm.applyTypeName = rowData.applyTypeName;
                if (rowData.applyPlanCode) this.applyForm.applyPlanCode = rowData.applyPlanCode;
                this.applyForm.applyTypeCode = rowData.applyTypeCode;
                this.applyForm.isDivideClassCourse = rowData.isDivideClassCourse;

                this.loadApplyCourseCombo(type);

                this.applyDialogVisible = true;
            },
            loadApplyCourseCombo(type) {
                this.$api.scoreManage.retake.queryApplyCourseCombo({
                    data: this.applyForm,
                }).then((res) => {
                    this.comboOption.applyCourse = res.data.data.applyCourseComboData;

                    if(type==='view' && this.applyForm.applyPlanCode){
                        this.handleApplyCourseChange(this.applyForm.applyPlanCode)
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            queryTimetable() {
                this.timetableLoading = true;

                this.$api.timetableManage.query.stu({
                    data: {
                        stuCode: this.applyForm.stuCode,
                        semesterCode: this.curSemesterCode,
                    },
                }).then((res) => {
                    this.timetableInfo = res.data.data.timetable.cellList;
                    this.parseTimetableInfo(this.timetableInfo);

                    this.weekDayDate = res.data.data.weekdayDate;
                    this.handleTimetableShow();
                }).catch((err) => {
                    this.timetableLoading = false;
                    console.log(err);
                });
            },
            parseTimetableInfo(timetableInfo) {
                const _this = this;

                timetableInfo.forEach((cell, index) => {
                    let tempContent = '';

                    //课程名称
                    let tempCourseName = _this.handleTimetableContent(cell.courseName);
                    if (tempCourseName.length > 0) {
                        tempContent = tempCourseName;

                        //非单周查询显示周次信息
                        if (!this.singleWeek) {
                            let weekNum = _this.handleTimetableContent(cell.weekNum);
                            if (weekNum.length > 0) tempContent += "<br/>" + weekNum;
                        }
                    }

                    document.getElementById('cell_' + index).innerHTML = tempContent;
                });
            },
            handleTimetableContent(str) {
                const strLenLimit = 8;

                if (str) {
                    if (str.length > strLenLimit) {
                        str = str.substring(0, strLenLimit - 1) + '…';
                    }
                } else {
                    str = '';
                }

                return str;
            },
            handleCoursePositionStyle(courseArrangeInfo) {
                if (courseArrangeInfo.length < 1) return;

                const timeArray = courseArrangeInfo.split(',');

                for (let index in timeArray) {
                    const tempArray = timeArray[index].split('@');
                    const orderNum = tempArray[0];
                    const weekNumArray = tempArray[1].split('#');

                    for (let i = 0; i < this.timetableInfo.length; i++) {
                        if (orderNum == this.timetableInfo[i].orderNum) {
                            let ele = document.getElementById('cell_' + i);
                            ele.style.background = 'rgba(85, 255, 127, 0.7)';
                            this.isTimeConflict = false;
                            break;
                        }
                    }
                }
            },
            handleTimetableShow() {
                if(this.applyForm.courseArrangeInfo != null){
                    this.handleTimetableStyle(this.applyForm.courseArrangeInfo);
                }
                this.createTempTimetable();
                this.fixTable();
                this.timetableLoading = false;
            },
            //创建临时表
            createTempTimetable() {
                $("#timetable").show();
                const tempTableClone = $("#timetable").clone(true);
                tempTableClone.attr("id", 'tempTimetable');
                $("#timetable").after(tempTableClone);
                $("#timetable").hide();
            },
            //锁定表头和列
            fixTable() {
                const TableID = 'tempTimetable';
                //显示的宽度和高度

                const width = $('#contentArea').width();
                const height = $('#contentArea').height();
                // const height = 1150;

                //创建框架
                if ($("#" + TableID + "_tableLayout").length != 0) {
                    $("#" + TableID + "_tableLayout").before($("#" + TableID));
                    $("#" + TableID + "_tableLayout").empty();
                } else {
                    $("#" + TableID).after("<div id='" + TableID + "_tableLayout' style='overflow:hidden; height:" +
                        height + "; width:" + width + ";'></div>");
                }

                $('<div id="' + TableID + '_tableFix"></div>' +
                    '<div id="' + TableID + '_tableHead"></div>' +
                    '<div id="' + TableID + '_tableColumn"></div>' +
                    '<div id="' + TableID + '_tableData"></div>').appendTo("#" + TableID + "_tableLayout");

                const oldtable = $("#" + TableID);
                const tableFixClone = oldtable.clone(true);
                tableFixClone.attr("id", TableID + "_tableFixClone");
                $("#" + TableID + "_tableFix").append(tableFixClone);
                const tableHeadClone = oldtable.clone(true);
                tableHeadClone.attr("id", TableID + "_tableHeadClone");
                $("#" + TableID + "_tableHead").append(tableHeadClone);
                const tableColumnClone = oldtable.clone(true);
                tableColumnClone.attr("id", TableID + "_tableColumnClone");
                $("#" + TableID + "_tableColumn").append(tableColumnClone);
                $("#" + TableID + "_tableData").append(oldtable);
                $("#" + TableID + "_tableLayout table").each(function() {
                    $(this).css("margin", "0");
                });

                //计算tableFix，tableHead的高度
                let HeadHeight = $("#" + TableID + "_tableHead thead").height();
                HeadHeight += 2;
                $("#" + TableID + "_tableHead").css("height", HeadHeight);
                $("#" + TableID + "_tableFix").css("height", HeadHeight);

                //计算tableFix，tableColumn的宽度
                let ColumnsWidth = 0;
                $("#" + TableID + "_tableColumn tr:eq(1) td:lt(" + 3 + ")").each(function() {
                    ColumnsWidth += $(this).outerWidth(true);
                });
                ColumnsWidth += 2;

                $("#" + TableID + "_tableColumn").css("width", ColumnsWidth);
                $("#" + TableID + "_tableFix").css("width", ColumnsWidth);

                //为tableHead和tableColumn添加联动的滚动条事件
                $("#" + TableID + "_tableData").scroll(function() {
                    $("#" + TableID + "_tableHead").scrollLeft($("#" + TableID + "_tableData").scrollLeft());
                    $("#" + TableID + "_tableColumn").scrollTop($("#" + TableID + "_tableData").scrollTop());
                });

                $("#" + TableID + "_tableFix").css({
                    "overflow": "hidden",
                    "position": "relative",
                    "z-index": "50"
                });
                $("#" + TableID + "_tableHead").css({
                    "overflow": "hidden",
                    "width": width,
                    "position": "relative",
                    "z-index": "45"
                });
                $("#" + TableID + "_tableColumn").css({
                    "overflow": "hidden",
                    "height": height,
                    "position": "relative",
                    "z-index": "40"
                });
                $("#" + TableID + "_tableData").css({
                    "overflow": "auto",
                    "width": width,
                    "height": height,
                    "position": "relative",
                    "z-index": "35"
                });

                //为较小的table修正样式
                if ($("#" + TableID + "_tableHead").width() > $("#" + TableID + "_tableFix table").width()) {
                    $("#" + TableID + "_tableHead").css("width", $("#" + TableID + "_tableFix table").width());
                    $("#" + TableID + "_tableData").css("width", $("#" + TableID + "_tableFix table").width());
                }
                if ($("#" + TableID + "_tableColumn").height() > $("#" + TableID + "_tableColumn table").height()) {
                    $("#" + TableID + "_tableColumn").css("height", $("#" + TableID + "_tableColumn table").height());
                    $("#" + TableID + "_tableData").css("height", $("#" + TableID + "_tableColumn table").height());
                }

                $("#" + TableID + "_tableFix").offset($("#" + TableID + "_tableLayout").offset());
                $("#" + TableID + "_tableHead").offset($("#" + TableID + "_tableLayout").offset());
                $("#" + TableID + "_tableColumn").offset($("#" + TableID + "_tableLayout").offset());
                $("#" + TableID + "_tableData").offset($("#" + TableID + "_tableLayout").offset());

                $('#' + TableID + '_tableData').css('width', width);
                $('#' + TableID + '_tableData').css('height', height);
                $('#tempTimetable_tableData .contentHide').css('color', '#FFFFFF');
                $('#tempTimetable_tableData .contentHide').css('background', '#FFFFFF');
            },
            closeDialog() {
                this.applyForm.applyPlanCode = null;
                this.applyForm.isDivideClassCourse = null;

                if (this.$refs['applyForm'] !== undefined) {
                    this.$nextTick(() => {
                        this.$refs['applyForm'].clearValidate();
                    });
                }
                this.restTimetableStyle();
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            closeLoadingMask() {
                if(this.loadingMask) this.loadingMask.close();
            },
        }
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    .customElRow .el-row {
        padding-bottom: 0;
    }

    .customElRow .el-form-item {
        padding: 0 !important;
    }

    #mobileMode {
        line-height: 0;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #timetableDialogScroll {
        height: 65vh;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }

    /*  */
    #mobileMode #contentArea {
        width: 96%;
        height: calc(100% - 160px);
        margin: 2%;
        border: 1px solid #DCDFE6;
        border-collapse: collapse;
        border-spacing: 0;
        overflow: hidden;
    }


    .timetable {
        border-collapse: collapse;
        border-spacing: 0;
        text-align: center;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
    }

    .timetable tr {
        height: 50px;
    }

    .timetable th {
        line-height: 20px;
        text-align: center;
    }

    .timetable td,
    .timetable th {
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        padding: 0;
    }

    .timetableTitle {
        background-color: #F1FAF6;
        font-weight: bold;
    }

    .separetor {
        border-bottom: 4px double #DCDFE6 !important;
    }

    .timetableContent {
        width: 195px;
        font-size: 14px;
    }

    .iclass-text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>



// WEBPACK FOOTER //
// retakeApply.vue?d6a6957a